import { categories } from "@/mocks/categories";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const categoryLinks = categories.slice(0, 7);
  const categoryLinks2 = categories.slice(7, 14);

  const guideLinks = [
    { name: "Superbuy Spreadsheet Guide", path: "/superbuy-spreadsheet-guide" },
    { name: "Shopping Guide for Beginners", path: "/superbuy-shopping-guide" },
    { name: "Best Superbuy Finds 2026", path: "/best-superbuy-finds-2026" },
    { name: "How to Order Guide", path: "/how-to-order-superbuy" },
  ];

  const safetyLinks = [
    { name: "Is Superbuy Safe?", path: "/superbuy-safety-review" },
    { name: "Superbuy vs Other Agents", path: "/superbuy-vs-agents" },
    { name: "Shipping Guide", path: "/superbuy-shipping-guide" },
    { name: "Payment Security", path: "/superbuy-payment-guide" },
  ];

  const seoLinks = [
    { name: "QC Inspection Guide", path: "/superbuy-qc-guide" },
    { name: "Streetwear Finds", path: "/superbuy-streetwear-finds" },
    { name: "Sneaker Spreadsheet", path: "/superbuy-sneaker-spreadsheet" },
    { name: "Hidden Gems 2026", path: "/superbuy-hidden-gems" },
  ];

  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="px-6 md:px-12 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <button
              onClick={() => { navigate("/"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              className="text-xl font-heading font-bold text-background-50 hover:text-accent-300 transition-colors cursor-pointer"
            >
              superbuy.sbs
            </button>
            <p className="mt-4 text-sm text-background-50/60 max-w-sm leading-relaxed">
              Your trusted source for the best superbuy spreadsheet finds, buying guides, and safety tips.
              Helping thousands of shoppers discover amazing products every day.
            </p>

            <form
              data-readdy-form=""
              id="newsletter-form"
              action="https://readdy.ai/api/form/d8ruk2jf81iibef4bia0"
              method="POST"
              className="mt-6 flex gap-2 max-w-sm"
            >
              <input
                type="email"
                name="email"
                required
                placeholder="Your email for updates"
                className="flex-1 px-4 py-2.5 bg-foreground-800 border border-foreground-700 rounded-lg text-sm text-background-50 placeholder:text-background-50/40 focus:outline-none focus:border-accent-400 transition-colors"
              />
              <button
                type="submit"
                className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-accent-500 rounded-lg hover:bg-accent-400 transition-colors cursor-pointer"
              >
                <i className="ri-notification-3-line text-background-50 text-lg"></i>
              </button>
            </form>

            <p className="mt-4 text-lg md:text-xl font-heading font-semibold text-background-50 leading-snug">
              The best<br />spreadsheet experience
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Categories</h4>
            <ul className="space-y-2.5">
              {categoryLinks.map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-accent-300 transition-colors cursor-pointer">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">More Categories</h4>
            <ul className="space-y-2.5">
              {categoryLinks2.map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-accent-300 transition-colors cursor-pointer">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {[...guideLinks.slice(0, 2), ...safetyLinks.slice(0, 2), ...seoLinks.slice(0, 2)].map((link) => (
                <li key={link.name}>
                  {link.path !== "#" ? (
                    <button
                      onClick={() => { navigate(link.path); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                      className="text-sm text-background-50/60 hover:text-accent-300 transition-colors cursor-pointer text-left"
                    >
                      {link.name}
                    </button>
                  ) : (
                    <span className="text-sm text-background-50/40">{link.name}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-700 px-6 md:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-background-50/50">
          Copyright &copy; 2026 superbuy.sbs. All rights reserved.
        </p>
        <div className="flex items-center gap-3">
          {["ri-twitter-x-line", "ri-instagram-line", "ri-youtube-line", "ri-pinterest-line"].map((icon) => (
            <a
              key={icon}
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 flex items-center justify-center rounded border border-foreground-600 text-background-50/60 hover:text-accent-300 hover:border-accent-400 transition-colors cursor-pointer"
            >
              <i className={`${icon} text-sm`}></i>
            </a>
          ))}
        </div>
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="text-xs text-background-50/50 hover:text-accent-300 transition-colors cursor-pointer"
        >
          Privacy Policy
        </a>
      </div>
    </footer>
  );
}